export default "__VITE_ASSET__BvgaJ39h__"